import React, { Component } from "react";
import crypto from "crypto";
import data from "./api";
import { store } from "react-notifications-component";
import "./App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import logo from "./Logo-EarthID-white.png"
import Swal from 'sweetalert2';
import ReactDOMServer from 'react-dom/server';
import jsQR from "jsqr";

const {
  listenForUserData,
  listenForServiceProviderResponse,
  generateQrCodeNest,
  registerVendor,
  getVendor
} = data;

const QR_TYPE_MAP = {
  login: "Secure Login",
  register: "User Registration",
  adminLogin: "Admin Authentication",
  default: "Verify Identity"
};

let showNotification = true;

class Navbar extends Component {
  state = {
    showSpinner: false,
    showBtn: true,
    requestNo: "",
    qrcode: false,
    response: false,
    btnText: "Login with EarthID",
    showText: true,
    showModal: true,
    modalHeading: false,
    isVerificationPopupOpen: false,
    isVerifying: false,
    isVerificationLoading: [true, true, true, true, true],
    verificationData: null,
    uploadedQrData: null,
    qrType: "default",
  };


  userDenied = () => {
    this.setState({
        response: false,
        showModal: false,
    });
    setTimeout(() => {
        document.getElementById("exampleModalLogin").click();
        if (showNotification === true) {
            showNotification = false;
            store.addNotification({
                title: "Error!",
                message: `User Didn't Authorize!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true,
                },
            });
        }
    }, 0);
};


updateNotificationState = () => {
    setTimeout(() => {
        showNotification = true;
    }, 100);
    this.redirectToGenerateCred();
};



listenForSocket = () => {
    listenForServiceProviderResponse((err, res) => {
      // console.log("nikhil", res);
        this.setState({
            qrcode: false,
            response: false,
            showSpinner: true,
            showText: false,
        });
    });

  listenForUserData(async (err, res) => {
        let bytes = res.userDetails || res.newreq;
        
        // Save bytes data to sessionStorage
  sessionStorage.setItem('profileData', JSON.stringify(bytes));
console.log('Got Session Data')
        this.setState({
            showQr: false,
            showSpinner: false,
        });
        let creditnals;
        let sessionKey;
        if (bytes === "denied" || bytes.permission === "denied") {
            this.userDenied();
        } else if(
            bytes.permission === "granted" ||
            bytes === "issuerLogin" ||
            bytes === "credentialsgenerated" ||
            bytes === "verifylogin" ||
            bytes === "success"
        ) {
            this.setState({
                response: true,
                showSpinner: false,
                loggedIn: true,
                showModal: false,
                btnText: "LogOut",
                bytes: "issuerLogin",
            });
            setTimeout(() => {
                document.getElementById("exampleModalLogin").click();
                let popMessage;
                if (showNotification === true) {
                    if (this.state.bytes === "credentialsgenerated") {
                        popMessage = "Credentials Generated";
                    } else {
                        popMessage = `Login Successful`;
                    }
                    showNotification = false;
                    store.addNotification({
                        title: "Success!",
                        message: popMessage,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: true,
                        },
                    });
                    if (bytes.permission === "granted") {
                        this.updateNotificationState();
                    }
                }
            }, 0);
        }  else {
            this.setState({
                response: false,
                showModal: false,
            });
            setTimeout(() => {
                document.getElementById("exampleModalLogin").click();
                if (showNotification === true) {
                    showNotification = false;
                    store.addNotification({
                        title: "Error!",
                        message: `User Didn't Authorize!`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: true,
                        },
                    });
                }
            }, 0);
        }
    });
};



generateQrCodeData = async () => {

    //registerVendor()
    getVendor()
        .then((d) => {
            const timestamp = Date.now();
            const hash = crypto
                .createHmac("sha256", d.secretKey)
                .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
                .digest("hex");
                console.log("Hash", hash)
            generateQrCodeNest(hash, d.apiKey, "Rejolut@1008", timestamp, "login")
                .then((data) => {
                    this.listenForSocket();
                    this.setState({
                        showQr: true,
                        qrCodeData: data,
                        apiKey: this.state.apikey,
                        qrcode: false,
                        qrType: "login",
                    });
                })
                .catch((err) => {
                    alert(err);
                });
        })
        .catch((err) => {
            alert(err);
        });
};

// Register functions

listenForSocketRegister = () => {
  listenForServiceProviderResponse((err, res) => {
    this.setState({
      qrcode: false,
      response: false,
      showSpinner: true,
      showText: false,
    });
  });

  listenForUserData(async (err, res) => {
    let bytes = res.userDetails || res.newreq;
    
    this.setState({
      showQr: false,
      showSpinner: false,
    });

    if (bytes === "denied" || bytes.permission === "denied") {
      this.userDenied();
    } else if (bytes.permission === "granted" || bytes.success || bytes.userDid) {
      console.log('this is user register data:', bytes)
      // --- START OF BACKEND INTEGRATION ---
      
      // 1. Prepare the payload from EarthID response

      const signupData = {
        name: bytes.userName || "EarthID User",
        phone: bytes.userMobileNo || "Not Provided",
        email: bytes.userEmail || "",
        userDid: bytes.userDid,
        earthId: bytes.earthId, 
        mediatorUrl: bytes.mediatorUrl || "https://default.mediator.com",
        fcmToken: bytes.fcmToken || "",
      };
      console.log('this is user register data2:', signupData)
      try {
        const response = await fetch("https://sangrahapi.myearth.id/api/v1/users/link-did", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(signupData),
        });

        const apiResult = await response.json();
console.log('this is user register api response:', apiResult)
        if (apiResult.success) {
          // Success Alert
          Swal.fire({
            icon: 'success',
            title: 'Registration Successful',
            text: 'Your EarthID has been linked to the Bank Portal.',
            timer: 3000,
            showConfirmButton: false
          });

          // Standard App Logic
          this.setState({
            response: true,
            loggedIn: true,
            showModal: false,
            btnText: "LogOut",
          });
          
          // Close the QR Modal programmatically
          document.getElementById("exampleModalLogin").click();

        } else {
          throw new Error(apiResult.message || "Backend registration failed");
        }

      } catch (error) {
        console.error("Registration Error:", error);
        
        // Failure Alert
        Swal.fire({
          icon: 'error',
          title: 'Registration Failed',
          text: error.message || 'Could not connect to the Bank Server.',
        });
      }
      
      // --- END OF BACKEND INTEGRATION ---

    } else {
      this.userDenied();
    }
  });
};

generateQrCodeDataRegister = async () => {

  registerVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
          generateQrCodeNest(hash, d.apiKey, "Rejolut@1008", timestamp, "register")
              .then((data) => {
                  this.listenForSocketRegister();
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                  });
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};

//Admin functions


adminNotificationState = () => {
  setTimeout(() => {
      showNotification = true;
  }, 100);
  this.redirectToAdmin();
};


redirectToAdmin() {
  window.location.href = "/admin";
}

listenForSocketAdmin = () => {
  listenForServiceProviderResponse((err, res) => {
    // console.log("nikhil", res);
      this.setState({
          qrcode: false,
          response: false,
          showSpinner: true,
          showText: false,
      });
  });

listenForUserData(async (err, res) => {
      let bytes = res.userDetails || res.newreq;
      console.log("bytes", bytes);
      this.setState({
          showQr: false,
          showSpinner: false,
      });
      let creditnals;
      let sessionKey;
      if (bytes === "denied" || bytes.permission === "denied") {
          this.userDenied();
      } else if (
          bytes.permission === "granted" ||
          bytes === "issuerLogin" ||
          bytes === "credentialsgenerated" ||
          bytes === "verifylogin" ||
          bytes === "success"
      ) {
          this.setState({
              response: true,
              showSpinner: false,
              loggedIn: true,
              showModal: false,
              btnText: "LogOut",
              bytes: "issuerLogin",
          });
          setTimeout(() => {
              document.getElementById("exampleModalLogin").click();
              let popMessage;
              if (showNotification === true) {
                  if (this.state.bytes === "credentialsgenerated") {
                      popMessage = "Credentials Generated";
                  } else {
                      popMessage = `Login Successful`;
                  }
                  showNotification = false;
                  store.addNotification({
                      title: "Success!",
                      message: popMessage,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                          duration: 3000,
                          onScreen: true,
                      },
                  });
                  if (bytes.permission === "granted") {
                      this.adminNotificationState();
                  } else if (bytes === "verifylogin") {
                      this.verifyNotificationState();
                  }
              }
          }, 0);
      } else {
          this.setState({
              response: false,
              showModal: false,
          });
          setTimeout(() => {
              document.getElementById("exampleModalLogin").click();
              if (showNotification === true) {
                  showNotification = false;
                  store.addNotification({
                      title: "Error!",
                      message: `User Didn't Authorize!`,
                      type: "danger",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                          duration: 3000,
                          onScreen: true,
                      },
                  });
              }
          }, 0);
      }
  });
};

generateQrCodeDataAdmin = async () => {

  registerVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
          generateQrCodeNest(hash, d.apiKey, "Rejolut@1008", timestamp, "login")
              .then((data) => {
                  this.listenForSocketAdmin();
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                  });
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};

//Admin Functions end

qrcode = () => {
    let { qrCodeData } = this.state;
    return (
        <div className="qr-container">
            <img src={qrCodeData} alt="new" />
        </div>
    );
};

redirectToHome() {
    window.location.href = "/";
}
redirectToGenerateCred() {
    window.location.href = "/generateCred";
}

showLoginPopup(userType) {
  const isCustomer = userType === 'customer';
  
  const popupContent = (
    <div style={{ textAlign: 'left', padding: '10px' }}>
      <p style={{ color: '#7f8c8d', fontSize: '14px', marginBottom: '20px' }}>
        Please enter your {userType} credentials to access the {isCustomer ? 'User' : 'Admin'} dashboard.
      </p>
      
      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#34495e', marginBottom: '5px', textTransform: 'uppercase' }}>Username</label>
        <input 
          type="text" 
          id="username" 
          className="swal2-input" 
          placeholder="e.g. tracysmith" 
          style={{ width: '100%', margin: '0', borderRadius: '8px', border: '1px solid #d1d8e0' }} 
        />
      </div>

      <div style={{ marginBottom: '5px' }}>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#34495e', marginBottom: '5px', textTransform: 'uppercase' }}>Password</label>
        <input 
          type="password" 
          id="password" 
          className="swal2-input" 
          placeholder="••••••••" 
          style={{ width: '100%', margin: '0', borderRadius: '8px', border: '1px solid #d1d8e0' }} 
        />
      </div>
    </div>
  );

  Swal.fire({
    title: `<span style="font-family: 'Poppins', sans-serif; font-weight: 700; color: #2c3e50;">${isCustomer ? 'Customer' : 'Admin'} Portal</span>`,
    html: ReactDOMServer.renderToStaticMarkup(popupContent),
    showCancelButton: true,
    confirmButtonText: 'Login',
    cancelButtonText: 'Back',
    buttonsStyling: false, // Custom button styles
    customClass: {
      confirmButton: 'custom-swal-confirm',
      cancelButton: 'custom-swal-cancel'
    },
    didOpen: () => {
      // Inline styling for the specific buttons to ensure uniformity
      const confirmBtn = Swal.getConfirmButton();
      const cancelBtn = Swal.getCancelButton();
      
      Object.assign(confirmBtn.style, {
        backgroundColor: '#3498db', color: '#fff', padding: '12px 40px', 
        borderRadius: '8px', border: 'none', fontWeight: '600', margin: '10px', cursor: 'pointer', width: '140px'
      });
      Object.assign(cancelBtn.style, {
        backgroundColor: '#fff', color: '#7f8c8d', padding: '12px 40px', 
        borderRadius: '8px', border: '1px solid #d1d8e0', fontWeight: '600', margin: '10px', cursor: 'pointer', width: '140px'
      });
    },
    preConfirm: () => {
      const username = Swal.getPopup().querySelector('#username').value;
      const password = Swal.getPopup().querySelector('#password').value;

      const userCredentials = {
        customer: { username: 'superadmin', password: 'S00per@2023' },
        admin: { username: 'tracysmith', password: 'Tracy@2026' },
      };

      if (username === userCredentials[userType].username && password === userCredentials[userType].password) {
        window.location.href = isCustomer ? '/generateCred' : '/admin';
      } else {
        Swal.showValidationMessage('Invalid credentials. Please try again.');
      }
    },
  });
}


//New QR code verification logic:
// Function to handle QR Upload and Verification Call
handleQrVerification = async () => {
    const { uploadedQrData } = this.state;
    
    if (!uploadedQrData) {
        Swal.fire("Error", "Please upload a QR code first", "error");
        return;
    }

    // Extracting data from the VC inside the QR
    const subject = uploadedQrData.vc.credentialSubject[0] || {};
    const fullName = `${subject.firstName || ''} ${subject.lastName || ''}`.trim();
    const expiryDate = subject.validUntil || uploadedQrData.vc.expirationDate || "N/A";
    
    // Formatting Current Date for "Verified On"
    const now = new Date();
    const verifiedOn = now.toLocaleDateString('en-GB') + ' ' + now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    this.setState({ 
        isVerificationPopupOpen: true, 
        isVerifying: true,
        isVerificationLoading: [true, true, true, true, true],
        verificationData: {
            issuer: "EarthID",
            subjectId: uploadedQrData.subject_id || "1011",
            verifiedFor: fullName || "Verified User",
            verifiedOn: verifiedOn,
            validUntil: expiryDate
        }
    });

    try {
        await fetch('https://did.myearth.id/v2/credentials/verify', {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'x-api-key': '987e6543-f21c-47e1-b103-435e614174005',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ credential: uploadedQrData.vc })
        });

        setTimeout(() => this.setState({ isVerifying: false }), 2000);

        for (let i = 0; i < 5; i++) {
            await new Promise(res => setTimeout(res, 1200));
            let newLoading = [...this.state.isVerificationLoading];
            newLoading[i] = false;
            this.setState({ isVerificationLoading: newLoading });
        }
    } catch (error) {
        console.error("Verification Error:", error);
        this.setState({ isVerificationPopupOpen: false });
        Swal.fire("Error", "Verification failed.", "error");
    }
};

decodeQrCode = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
            // Create a canvas to extract pixel data
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = image.width;
            canvas.height = image.height;
            context.drawImage(image, 0, 0, image.width, image.height);

            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            
            // Use jsQR to decode
            const code = jsQR(imageData.data, imageData.width, imageData.height, {
                inversionAttempts: "dontInvert",
            });

            if (code) {
                try {
                    const decodedData = JSON.parse(code.data);
                    console.log("Decoded QR Data:", decodedData);
                    
                    this.setState({ uploadedQrData: decodedData }, () => {
                        this.handleQrVerification();
                    });
                } catch (err) {
                    Swal.fire("Format Error", "QR code detected, but content is not valid JSON.", "error");
                }
            } else {
                Swal.fire("Scan Failed", "Could not find a QR code in this image. Make sure the QR is clearly visible.", "error");
            }
        };
    };
    reader.readAsDataURL(file);
};

// Function to handle File Input in Swal
handleQrUploadPopup = () => {
    Swal.fire({
        title: '<span style="font-family: \'Poppins\', sans-serif; font-weight: 600; color: #2c3e50;">Verify QR Code</span>',
        html: `
            <div style="padding: 10px; font-family: 'Poppins', sans-serif;">
                <p style="color: #7f8c8d; font-size: 0.95rem; margin-bottom: 25px;">
                    Select the QR code image received on WhatsApp
                </p>
                <div style="position: relative; margin-bottom: 20px;">
                    <input type="file" id="qrFileInput" accept="image/*" style="display: none;" 
                        onchange="document.getElementById('file-name-display').innerText = this.files[0].name">
                    <button type="button" onclick="document.getElementById('qrFileInput').click()" 
                        style="background-color: #f8f9fa; border: 2px dashed #d1d8e0; border-radius: 8px; padding: 15px 20px; width: 100%; cursor: pointer; transition: all 0.3s ease;">
                        <span id="file-name-display" style="color: #4b6584; font-weight: 500;">Click to upload screenshot</span>
                    </button>
                </div>
            </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Verify Proof',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        didOpen: () => {
            const confirmBtn = Swal.getConfirmButton();
            const cancelBtn = Swal.getCancelButton();
            
            // Apply modern styles
            Object.assign(confirmBtn.style, {
                backgroundColor: '#3498db', color: '#fff', padding: '12px 30px', 
                borderRadius: '8px', border: 'none', fontWeight: '600', margin: '0 10px', cursor: 'pointer'
            });
            Object.assign(cancelBtn.style, {
                backgroundColor: '#ecf0f1', color: '#7f8c8d', padding: '12px 30px', 
                borderRadius: '8px', border: 'none', fontWeight: '600', margin: '0 10px', cursor: 'pointer'
            });
        },
        preConfirm: () => {
            const file = document.getElementById('qrFileInput').files[0];
            if (!file) {
                Swal.showValidationMessage('Please select an image first');
                return false;
            }
            return file;
        }
    }).then((result) => {
        if (result.isConfirmed) {
            this.decodeQrCode(result.value);
        }
    });
};


  render() {
    let showButton = this.state.showSpinner ? (
      <div className="spinner-div">
        <img className="spinner" src={require("./spinner.gif")} />
      </div>
    ) : null;
    return (
      <div className="App">

<nav className="navbar navbar-expand-lg navbar-light">
          <div
            className=" collapse navbar-collapse pull-right "
            id="navbarTogglerDemo01"
          >
            <div className="clickable" onClick={() => window.open("https://www.myearth.id/")}> 
              <img src={logo} alt="logo" className="logo"  />{" "}
            </div>
            <ul className=" navbar-nav mr-auto mt-2 mt-lg-0" style={{marginLeft:"1.5rem", textTransform:"uppercase"
            , color:"White"}}>
                    <li className="nav-item">
                        <a className="nav-link active" aria-current="page" href="#">Plans</a>
                    </li>
                    {/* <li className="nav-item">
                        <a className="nav-link" href="#">Services</a>
                    </li> */}
                    <li className="nav-item">
                        <a className="nav-link" href="#">Business</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#">Investment</a>
                    </li>
            </ul>

            {localStorage.user_name ? (
              <div>
                <label className="welcomeLabel">{`Welcome, ${localStorage.getItem(
                  "user_name"
                )}`}</label>
              </div>
            ) : null}

<div className="profileAccess">
              {window.location.pathname == "/" ? (
                <div className="row">
                {/* <button
                  type="button"
                  className="nav-buttons"
                  data-toggle="modal"
                  data-target="#exampleModalLogin"
                  onClick={this.state.btnText=="LogOut"?this.redirectToHome:this.generateQrCodeData}
                  style={{ marginRight: "2rem", marginLeft: "2rem" }}
                >
                  Customer Login
                </button>
                <button
                  type="button"
                  className="nav-buttons"
                  data-toggle="modal"
                  data-target="#exampleModalLogin"
                  onClick={this.state.btnText=="LogOut"?this.redirectToHome:this.generateQrCodeDataAdmin}
                  style={{ marginRight: "2rem", marginLeft: "2rem" }}
                >
                  Admin Login
                </button> */}
{/* <button
                  type="button"
                  className="nav-buttons"
                  data-toggle="modal"
                  data-target="#exampleModalLogin"
                  onClick={this.state.btnText=="LogOut"?this.redirectToHome:this.generateQrCodeDataRegister}
                  style={{ marginRight: "2rem", marginLeft: "2rem" }}
                >
                  Register
                </button> */}
                {/* <button
    type="button"
    className="nav-buttons"
    onClick={this.handleQrUploadPopup}
    style={{ marginRight: "2rem", marginLeft: "2rem" }}
>
    Verify Proof
</button> */}
<div className='dropdown'>
                                    <button
                                        className='nav-buttons dropdown-toggle'
                                        type='button'
                                        id='certificateDropdown'
                                        data-toggle='dropdown'
                                        aria-haspopup='true'
                                        aria-expanded='false'
                                        style={{ marginRight: "2rem", marginLeft: "2rem" }}
                                    >
                                        {'Customer Login'}
                                    </button>
                                    <div className='dropdown-menu dropdown-menu-right' aria-labelledby='certificateDropdown'>
                                        <a
                                            className='dropdown-item'
                                            onClick={() => this.showLoginPopup('customer')}
                                            style={{ cursor: "pointer" }}
                                        >
                                            Login with Credentials
                                        </a>
                                        <a
                                            className='dropdown-item'
                                            data-toggle="modal"
                    data-target="#exampleModalLogin"
                    style={{ cursor: "pointer" }}
                                            onClick={this.state.btnText=="LogOut"?this.redirectToHome:this.generateQrCodeData}
                                        >
                                            Login with EarthID
                                        </a>
                                       
                                        
                                    </div>
                                </div>

                                <div className='dropdown'>
                                    <button
                                        className='nav-buttons dropdown-toggle'
                                        type='button'
                                        id='certificateDropdown'
                                        data-toggle='dropdown'
                                        aria-haspopup='true'
                                        aria-expanded='false'
                                        style={{ marginRight: "2rem", marginLeft: "2rem" }}
                                    >
                                        {'Admin Login'}
                                    </button>
                                    <div className='dropdown-menu dropdown-menu-right' aria-labelledby='certificateDropdown'>
                                    <a
                                            className='dropdown-item'
                                            onClick={() => this.showLoginPopup('admin')}
                                            style={{ cursor: "pointer" }}
                                        >
                                            Login with Credentials
                                        </a>
                                        <a
                                            className='dropdown-item'
                                            data-toggle="modal"
                    data-target="#exampleModalLogin"
                    style={{ cursor: "pointer" }}
                                            onClick={this.state.btnText=="LogOut"?this.redirectToHome:this.generateQrCodeDataAdmin}
                                        >
                                            Login with EarthID
                                        </a>
                                        
                                        
                                    </div>
                                </div>
                </div>
              ) : window.location.pathname == "/" ? (
                <div>
                  {/* <button
                    style={{ marginRight: "300px" }}
                    type="button"
                    className="nav-buttons"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={this.verifyQrCodeData
                    }
                  >
                    Verify Credentials
                  </button>
                  {" "}
                  <button
                    type="button"
                    className="nav-buttons"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={this.redirectToHome}
                  >
                    Logout
                  </button> */}
                </div>
              ) :(
                <div>

                </div>
              )
              }

              {/* {this.state.loggedIn ? (
                <div className="dropDown">
                  {this.state.profileDrop ? (
                    <div>
                      <ul className="dropdown-profile">
                        <li
                          className="dropdown-list1"
                          onClick={() => this.redirectToProfile()}
                        >
                          My Profile
                        </li>
                        <li
                          className="dropdown-list1"
                          onClick={() => this.redirectToDocuments()}
                        >
                          {" "}
                          Submit Kyc Documents
                        </li>
                        <li
                          className="dropdown-list1"
                          onClick={() => this.redirectToGenerateCred()}
                        >
                          {" "}
                          Generate Credentials
                        </li>
                        <li className="dropdown-list" onClick={this.loader}>
                          LogOut
                        </li>
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : null} */}
            </div>
            </div>
</nav>



          <div className="modal_container" id="modal-container">
            <div className="modal">
              <div className="qr-code">
                <img
                  src='https://api.qrserver.com/v1/create-qr-code/?data={"apikey":"UKURGTREFATPSYJ","reqNo":"BAZQUVRDTLF","sessionKey":"BAZQUVRDTLF","requestType":"login","encryptionkey":"loginDetailsEncryption" }'
                  alt="QR-Code"
                />
              </div>

              <button id="btn-close">Close me</button>
            </div>
          </div>

          <div className="hero-section">
          <div className="shoppingCart"></div>
          <div
            className="modal fade"
            id="exampleModalLogin"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              {
                <div>
                  {this.state.showModal ? (
                    <div className="modal-content" style={{ borderRadius: '15px', overflow: 'hidden' }}>
  {/* Modal Header */}
  <div className="close-button-containerr" style={{ borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <h4 style={{ color: "black", margin: 0, fontWeight: '600' }}>
      {QR_TYPE_MAP[this.state.qrType] || QR_TYPE_MAP.default}
    </h4>
    <FontAwesomeIcon 
      className="close-buttonn" 
      data-dismiss="modal" 
      icon={faClose} 
      style={{ cursor: 'pointer', fontSize: '20px' }} 
    />
  </div>

  <div className="modal-body" style={{  textAlign: 'center' }}>
    {/* Instructions */}
    <div style={{ marginBottom: '20px' }}>
      <p style={{ color: '#555', fontSize: '15px', marginBottom: '5px' }}>
        <strong>Scan using your Sangrah Wallet</strong>
      </p>
      {/* <p style={{ color: '#888', fontSize: '12px' }}>
        Open your app, tap the scan icon, and point your camera at the code below.
      </p> */}
    </div>

    <div className="pop-upbox" style={{ background: '#f9f9f9', padding: '20px', borderRadius: '12px', display: 'inline-block' }}>
      {/* Show static QR if it exists and we aren't waiting for a response */}
      {!this.state.response && this.state.showQr && (
        <div className="qr-wrapper" style={{ border: '10px solid white', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
          {this.qrcode()}
        </div>
      )}
    </div>

    {/* Status Indicator */}
    <div style={{ marginTop: '25px', paddingTop: '20px', borderTop: '1px solid #f0f0f0' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', color: '#000000', fontSize: '13px' }}>
        <div className="pulse-dot" style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#000000' }}></div>
        Waiting for confirmation…
      </div>
    </div>
    <p style={{ color: '#888', fontSize: '12px' }}>
                Tip: Ensure your Sangrah app is installed and logged in, then scan the code above.
              </p>
  </div>
</div>
                  ) : null}
                </div>
              }
            </div>
          </div>
        </div>
     
{this.state.isVerificationPopupOpen && (
  <div className="popup-container">
    {this.state.isVerifying ? (
      <div className="text-center">
        <div className="spinner"></div>
        <div className="spinner-text">Verifying Credentials...</div>
      </div>
    ) : (
      <div className="popup">
        <div className="popup-header">
          <div className="popup-title">Verification Result</div>
          <button className="popup-close" onClick={() => this.setState({ isVerificationPopupOpen: false })}>
            <FontAwesomeIcon icon={faClose} style={{ fontSize: "25px", color: "#7f7f7f" }} />
          </button>
        </div>
        <hr />
        <div className="popup-body">
          
          {/* Item 1: Verified By */}
          <div className="verification-item">
            <div className="verification-result">
              {this.state.isVerificationLoading[0] ? <div className="spinner1"></div> : <div className="success">&#10004;</div>}
            </div>
            {!this.state.isVerificationLoading[0] ? (
              <div className="content-fade-in">
                <div className="flex-row">
                  <div className="verification-label">Verified By:</div>
                  <div className="verification-result1cms">{this.state.verificationData.issuer}</div>
                </div>
                <div className="verification-detail">This information has been validated against a trusted source.</div>
              </div>
            ) : <div className="verification-label-loading">Verifying Issuer...</div>}
          </div>
          <hr />

          {/* Item 2: Attributes */}
          <div className="verification-item">
            <div className="verification-result">
              {this.state.isVerificationLoading[1] ? <div className="spinner1"></div> : <div className="success">&#10004;</div>}
            </div>
            {!this.state.isVerificationLoading[1] ? (
              <div className="content-fade-in">
                <div className="flex-row">
                  <div className="verification-label">Verified Identity Attributes:</div>
                  <div className="verification-result1cms">Successfully Verified</div>
                </div>
                <div className="verification-detail">Age Check: Over 18 ✔</div>
              </div>
            ) : <div className="verification-label-loading">Checking Identity Attributes...</div>}
          </div>
          <hr />

          {/* Item 3: Subject */}
          <div className="verification-item">
            <div className="verification-result">
              {this.state.isVerificationLoading[2] ? <div className="spinner1"></div> : <div className="success">&#10004;</div>}
            </div>
            {!this.state.isVerificationLoading[2] ? (
              <div className="content-fade-in">
                <div className="flex-row">
                  <div className="verification-label">Verified For:</div>
                  <div className="verification-result1cms" style={{textTransform: 'uppercase'}}>{this.state.verificationData.verifiedFor}</div>
                </div>
                <div className="flex-row">
                  <div className="verification-label">Verification ID:</div>
                  <div className="verification-result1cms">{this.state.verificationData.subjectId}</div>
                </div>
                <div className="verification-detail">The recipient of this credential has been verified.</div>
              </div>
            ) : <div className="verification-label-loading">Verifying Recipient...</div>}
          </div>
          <hr />

          {/* Item 4: Dates */}
          <div className="verification-item">
            <div className="verification-result">
              {this.state.isVerificationLoading[3] ? <div className="spinner1"></div> : <div className="success">&#10004;</div>}
            </div>
            {!this.state.isVerificationLoading[3] ? (
              <div className="content-fade-in">
                <div className="flex-row">
                  <div className="verification-label">Verified On:</div>
                  <div className="verification-result1cms">{this.state.verificationData.verifiedOn}</div>
                </div>
                <div className="flex-row">
                  <div className="verification-label">Verified Until:</div>
                  <div className="verification-result1cms">{this.state.verificationData.validUntil}</div>
                </div>
              </div>
            ) : <div className="verification-label-loading">Checking Validity Dates...</div>}
          </div>
          <hr />

          {/* Item 5: Summary */}
          <div className="verification-item">
            <div className="verification-result">
              {this.state.isVerificationLoading[4] ? <div className="spinner1"></div> : <div className="success-green">&#10004;</div>}
            </div>
            {!this.state.isVerificationLoading[4] ? (
              <div className="content-fade-in">
                <div className="summary-title">Summary</div>
                <div className="verification-detail">This identity verification has been completed successfully and is valid for the stated purpose.</div>
              </div>
            ) : <div className="verification-label-loading">Finalizing Proof...</div>}
          </div>
        </div>
      </div>
    )}
  </div>
)}
      
      </div>
    );
  }
}

export default Navbar;